// Resist the urge to move these to @api imports, it'll break the dependency chain
import React from 'react'
import HighlighterInternal from 'react-highlight-words'
import _ from 'lodash'
import * as css from './Highlighter.css'
import classNames from 'classnames'

HighlighterInternal.defaultProps = _.merge({}, HighlighterInternal.defaultProps, {autoEscape: true})
export const Highlighter = React.forwardRef<HTMLDivElement, { className?: string, textToHighlight: string, searchWords?: Array<string>, autoEscape?: boolean, caseSensitive?: boolean }>(
  function HighlighterWithRef({className, ...props}, ref) {
    return (
      <div className={classNames(css.root, className)} ref={ref}>
        <HighlighterInternal {...props} />
      </div>)
  })



// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/Highlighter.tsx